<div class="prolex-page-wrapper">
	<landing-page-header></landing-page-header>
	<router-outlet></router-outlet>
	<landing-page-footer></landing-page-footer>
</div>
<a href="#" data-target="html" class="scroll-to-target prolex-scroll-to-top">
	<i class="cis-chevron-circle-up" style="background-color:#ffffff;border-radius:50px;"></i>
</a>
